export default __webpack_public_path__ + "a875568f25bb3d16a2f68e7045ba3540.svg";